<template>
    <div>
        <v-container class="mb-10 elevation-12">
            <v-simple-table style="border:solid,1px;padding:4px" class="scheduletable">
                <thead>
                    <tr>
                        <th style="font-size:20px"></th>
                        <th v-for="date in dates" :key="date.id">
                            <p
                                style="font-size:20px;color:white;background-color:orange;max-width:130px;border-radius:5px;padding:2px"
                            >
                                {{ toDDMMMYY(date.schedule_date) }}
                            </p>
                            <p>
                                {{ toMMHH(date.time_from) }} to
                                {{ toMMHH(date.time_to) }}
                            </p>
                        </th>
                        <!-- <th
                            v-for="det in contact"
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            :key="det"
                        >
                            {{ det }}
                        </th> -->
                    </tr>

                    <tr>
                        <th style="font-size:15px">Deltagarens namn</th>
                    </tr>
                    <tr
                        v-show="schedule[0].hidden_schedule === 'no' || schedule[0].user_id === store.state.user.id"
                        v-for="participant in participation_table"
                        :key="participant.id"
                    >
                        <td>{{ participant.name }}</td>
                        <!-- <td>{{ participant.comment }}</td> -->
                        <td v-for="date in participant.dates" :key="date.id">
                            <p v-if="date.status == 1">
                                <v-icon style="margin-left:10px;color:green"
                                    >fas fa-check</v-icon
                                >
                            </p>
                            <p v-else-if="date.status == 0">
                                <v-icon style="margin-left:10px;color:red"
                                    >fas fa-times</v-icon
                                >
                            </p>
                            <p v-else>Om det behövs</p>
                            <p>{{ date.comment }}</p>
                        </td>
                        <!-- <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci0 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci1 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci2 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci3 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci4 }}
                        </td> -->
                    </tr>
                    <tr v-if="schedule[0].one_answer == 'no' && !datePassed()">
                        <td>
                            <v-text-field
                                v-model="name"
                                placeholder="ditt namn"
                                required
                            />
                        </td>
                        <!-- <td>
                            <v-text-field
                                v-model="comment"
                                placeholder="Kommentar"
                                required
                            />
                        </td> -->
                        <td v-for="(date, i) in selectedDates" :key="i">
                            <v-checkbox v-model="date.status" v-if="schedule[0].if_needed_option === 'no'"/>
                            <v-radio-group
                                style="display:flex"
                                v-model="date.status"
                                v-if="schedule[0].if_needed_option === 'yes'"
                            >
                                <v-row>
                                    <v-radio
                                        class="radio"
                                        v-for="(checkbox, i) in checkBoxes"
                                        :key="i"
                                        :label="checkbox.label"
                                        :value="checkbox.value"
                                    />
                                </v-row>
                            </v-radio-group>
                            <v-row
                                ><v-text-field
                                    label="Kommentarer"
                                    v-model="dateComments[i].comment"
                                />
                            </v-row>
                        </td>
                        <!-- <td
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            v-for="(det, i) in contact"
                            :key="det"
                        >
                            <v-text-field :label="det" v-model="ci[i]" />
                        </td> -->
                        <!-- <td>
                            <v-btn
                                style="background-color:#ffa500;margin-bottom:20px"
                                @click="submit"
                                >Sända
                                <v-icon style="margin-left:3px;font-size:15px">
                                    fas fa-check</v-icon
                                ></v-btn
                            >
                        </td> -->
                    </tr>

                    <tr
                        v-if="
                            !alreadyReplied() &&
                                schedule[0].one_answer == 'yes' &&
                                !datePassed()
                        "
                    >
                        <td>
                            <v-text-field
                                v-model="name"
                                placeholder="ditt namn"
                                required
                            />
                        </td>
                        <!-- <td>
                            <v-text-field
                                v-model="comment"
                                placeholder="Kommentar"
                                required
                            />
                        </td> -->
                        <td v-for="(date, i) in selectedDates" :key="i">
                            <v-checkbox v-model="date.status" v-if="schedule[0].if_needed_option === 'no'"/>
                            <v-radio-group
                                style="display:flex"
                                v-model="date.status"
                                v-if="schedule[0].if_needed_option === 'yes'"
                            >
                                <v-row>
                                    <v-radio
                                        class="radio"
                                        v-for="(checkbox, i) in checkBoxes"
                                        :key="i"
                                        :label="checkbox.label"
                                        :value="checkbox.value"
                                    />
                                </v-row>
                            </v-radio-group>
                            <v-row
                                ><v-text-field
                                    label="Kommentarer"
                                    v-model="dateComments[i].comment"
                                />
                            </v-row>
                        </td>
                        <!-- <td
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            v-for="(det, i) in contact"
                            :key="det"
                        >
                            <v-text-field :label="det" v-model="ci[i]" />
                        </td> -->
                        <td>
                            
                        </td>
                    </tr>
                    <tr
                        v-if="
                            schedule[0].one_answer == 'yes' && alreadyReplied()
                        "
                    >
                        <td style="text-align:center" colspan="5">
                            <!-- {{alreadyReplied()}} -->
                            Du har redan svarat för det här schemat
                        </td>
                    </tr>
                    <tr v-if="datePassed()">
                        <td style="text-align:center" colspan="5">
                            Svardatum för schemat passeras
                        </td>
                    </tr>
                </thead>
            </v-simple-table>
            <div v-show="schedule[0].ask_for_contact == 'yes'" v-if="!datePassed()">
                <v-text-field label="E-mail" v-model="email" required/>
                <v-text-field label="Phone" v-model="phone" required/>
            </div>
            <div v-if="!datePassed()">
            <div
            v-show="det && schedule[0].ask_for_contact == 'yes'"
            v-for="(det, i) in contact"
            :key="det"
        >
            <v-text-field :label="det" v-model="ci[i]" />
        </div>
        </div>
        <v-alert v-model="alert" type="error" dismissible>
            {{alertmsg}}
        </v-alert>
            <v-btn
            style="background-color:#ffa500;"
            @click="submit"
            class="float-right"
            >Sända
            <v-icon style="margin-left:3px;font-size:15px">
                fas fa-check</v-icon
            ></v-btn
        >
        </v-container>
        
        <v-container
            class="mb-10 elevation-12"
            v-if="!datePassed()"
        >
            <h4>Alla med länken kan rösta - inget konto behövs</h4>
            <br />
            <p>
                {{ copyLink() }}
                <v-btn v-clipboard="copyLink" text>
                    <v-icon>fas fa-copy</v-icon>
                </v-btn>
            </p>
            <p class="social">
                <a :href="'https://www.facebook.com/sharer/sharer.php?u='+shareLink" target="_blank" class="mr-2 text-decoration-none"><v-icon>fab fa-facebook</v-icon></a>
                <a :href="'https://api.whatsapp.com/send?text='+shareLink" target="_blank" class="mr-2"><v-icon>fab fa-whatsapp</v-icon></a>
                <a :href="'http://www.twitter.com/share?url='+shareLink" target="_blank" class="mr-2"><v-icon>fab fa-twitter</v-icon></a>
                <a :href="'https://telegram.me/share/url?url='+shareLink" target="_blank" class="mr-2"><v-icon>fab fa-telegram</v-icon></a>
                <a :href="'mailto:?body='+shareLink" target="_blank" class="mr-2"><v-icon>fas fa-envelope</v-icon></a>
            </p>
        </v-container>
        <v-container class="elevation-12">
            <h4>Kommentar</h4>
            <br />
            <div v-for="com in comments" v-bind:key="com.id">
                <v-flex>
                <v-avatar color="grey">
                <v-icon >fas fa-user-circle</v-icon>
                </v-avatar>
                </v-flex>
                <v-flex>
                <h4>{{com.name}}</h4>
                <p>{{com.comment}}</p>
                <!-- <timeago :since="com.created_at"></timeago> -->
                <v-divider></v-divider>
                </v-flex>
            </div>
            <v-textarea
            v-model="comment"
            required
            v-if="!datePassed()"
            />
            <v-alert v-model="alertc" type="error" dismissible>
            {{alertmsgc}}
        </v-alert>
            <v-btn
            v-if="!datePassed()"
            style="background-color:#ffa500;"
            @click="submitComment"
            >Publicera kommentar
            <v-icon style="margin-left:3px;font-size:15px">
                fas fa-check</v-icon
            ></v-btn
        >
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: ["store"],
    data: function() {
        return {
            schedule: {},
            dates: [],
            month: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
            participants: [],
            participant_dates: [],
            participation_table: [],
            name: "",
            alertmsg: "",
            alertmsgc: "",
            alert: false,
            alertc: false,
            selectedDates: [],
            comment: "",
            comments: [],
            email: '',
            phone: '',
            shareLink: "",
            dateComment: "",
            dateComments: [],
            contact: [],
            ci: [],
            checkBoxes: [
                {
                    label: "Ja",
                    value: 1
                },
                {
                    label: "Nej",
                    value: 0
                },
                {
                    label: "Om det behövs",
                    value: 2
                }
            ]
        };
    },
    async created() {
        (this.schedule = this.store.state.getSchedule.details),
            (this.dates = this.store.state.getSchedule.dates),
            (this.participants = this.store.state.getSchedule.participants),
            (this.participant_dates = this.store.state.getSchedule.participantDates);
        this.shareLink = `https://tid.nu/schedule/${this.schedule[0].schedule_link}`;
        for (var i = 0; i < this.participants.length; i++) {
            var participant = {
                id: i,
                name: this.participants[i].name,
                comment: this.participants[i].comment,
                dates: [],
                email: this.participants[i].email,
                phone: this.participants[i].phone,
                ci0: this.participants[i].ci0,
                ci1: this.participants[i].ci1,
                ci2: this.participants[i].ci2,
                ci3: this.participants[i].ci3,
                ci4: this.participants[i].ci4
            };
            for (var j = 0; j < this.participant_dates.length; j++) {
                if (
                    this.participants[i].id ===
                    this.participant_dates[j].participant_id
                )
                    participant.dates.push({
                        date: this.participant_dates[j].id,
                        status: this.participant_dates[j].participant_status,
                        comment: this.participant_dates[j].comment
                    });
            }
            this.participation_table = [
                ...this.participation_table,
                participant
            ];
            participant = { id: 0, name: "", dates: [] };
        }
        for (i = 0; i < this.dates.length; i++) {
            this.selectedDates[i] = { id: this.dates[i].id, status: false };
        }
        this.selectedDates.forEach(date => {
            this.dateComments.push({ id: date.id, comment: "" });
        });
        this.contact = [
            this.schedule[0].contact_info1,
            this.schedule[0].contact_info2,
            this.schedule[0].contact_info3,
            this.schedule[0].contact_info4,
            this.schedule[0].contact_info5
        ];
        this.getComments()
    },
    methods: {
        submit: async function() {
            if (this.name === '') {
                this.alertmsg = "Vänligen fyll i ditt namn";
                this.alert = true;
                return;
            }else if(this.email === ''){
                this.alertmsg = "Ange din e-postadress";
                this.alert = true;
                return;
            }else if(this.phone === ''){
                this.alertmsg = "Ange din mobil";
                this.alert = true;
                return;
            }
            let bodyFormData = new FormData();
            await bodyFormData.append(
                "dates",
                JSON.stringify({ dates: this.selectedDates })
            );
            await bodyFormData.append(
                "schedule_id",
                this.store.state.getSchedule.details[0].id
            );
            if (this.store.state.user.id)
                await bodyFormData.append("user_id", this.store.state.user.id);
            else await bodyFormData.append("user_id", 0);
            await bodyFormData.append("name", this.name);
            await bodyFormData.append("comment", this.comment);
            await bodyFormData.append("email", this.email);
            await bodyFormData.append("phone", this.phone);

            await bodyFormData.append(
                "DateComments",
                JSON.stringify(this.dateComments)
            );

            for (var i = 0; i < 5; i++) {
                if (this.ci[i] != null)
                    bodyFormData.append(`ci${i}`, this.ci[i]);
            }
            var config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await this.store.dispatch("addParticipant", config);
            window.location.reload();
        },
        add: function(id) {
            for (var i = 0; i < this.selectedDates.length; i++)
                if (this.selectedDates[i].id === id)
                    this.selectedDates[i].status = 1;
        },
        remove: function(id) {
            for (var i = 0; i < this.selectedDates.length; i++)
                if (this.selectedDates[i].id === id)
                    this.selectedDates[i].status = 0;
        },
        copyLink: function() {
            return this.shareLink;
        },
        alreadyReplied: function() {
            return this.participants.some(
                part => part.user_id == this.store.state.user.id
            );
        },
        datePassed: function() {
            if (this.schedule[0].reply_deadline == "no") return false;

            let date = new Date(Date.now());
            let replyDeadline = new Date(this.schedule[0].reply_deadline_date);
            return date > replyDeadline;
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        toDDMMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()} ${this.month[dated.getMonth()]} ${dated.getFullYear()}`;
        },
        toMMHH(time) {
            return time.substring(0, 5);
        },
        getComments: async function() {
            var config = {
            method: "get",
            url: `${this.store.state.baseURL}schedule_comments/${this.store.state.getSchedule.details[0].id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.comments = resp.data.comments;
        },
        submitComment: async function() {
            if (this.comment === '') {
                this.alertmsgc = "Skriv en kommentar";
                this.alertc = true;
                return;
            }
            let bodyFormData = new FormData();
            await bodyFormData.append("comment", this.comment);
            bodyFormData.append("user_id", this.store.state.user.id);
            bodyFormData.append("schedule_id", this.store.state.getSchedule.details[0].id);
            var config = {
                method: "post",
                url:`${this.store.state.baseURL}addcomment`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await axios(config);
            this.getComments()
            this.comment = ''
        },
    }
};
</script>

<style scopped>
.btn1 {
    height: 5px;
    width: 10px;
}
.v-radio {
    margin-bottom: 8px;
}
.social a {
    text-decoration: none;
}
.required label::after {
    content: "*";
}
.scheduletable tr{
    border-bottom: 1px solid #ccc !important;
}
</style>
